import { FILE_TYPES } from "../pages/app/utils/constants";
import { existsString } from "./validation";

export const getExtension = (fileType) => {
  if (existsString(fileType)) {
    return `.${fileType.toLowerCase()}`;
  }
  return "";
};

export const getSequence = (fileType, fileName) => {
  if (fileType === "INT16") {
    return 0;
  }

  const extension = getExtension(fileType);

  if (existsString(fileName) && existsString(extension)) {
    const startIndex = fileName.length - (3 + extension.length);
    const seqString = fileName.substring(startIndex, startIndex + 3);
    const sequence = parseInt(seqString);
    if (isNaN(sequence)) return 0;
    return sequence;
  }
  return 0;
};

export const getFileType = (fileName) => {
  if (existsString(fileName)) {
    for (let ft of FILE_TYPES) {
      const extension = getExtension(ft.value);
      const filenameExtension = fileName
        .substring(fileName.lastIndexOf("."))
        .toLowerCase();
      if (filenameExtension.indexOf(extension) >= 0) {
        return ft.value.toUpperCase();
      }
    }
  }
  return undefined;
};
